import register from '../register.js';

register( 'privacy-toc', () => {

  let container = document.querySelector('.js-privacy-toc');
  let links = null;
  let headings = null;
  let opts = {
    rootMargin: '0px',
    threshold: 1
  };
  let observer = new IntersectionObserver( handleObserver, opts );
  let prevSection = null;

  function findLinksAndHeadings() {
    links = [ ...container.querySelectorAll('a') ];
    headings = links.map( link => {
      let id = link.getAttribute('href');
      return document.querySelector( id );
    });
  }

  function highlightActive() {
    let firstVisible = container.querySelector('.visible');

    links.forEach( link => {
      link.classList.remove('active');
    });

    if ( firstVisible ) {
      firstVisible.classList.add('active');
    }

    if ( !firstVisible && prevSection ) {
      container.querySelector(
        `a[href="#${ prevSection }"]`
      ).classList.add('active');
    }
  }

  function handleObserver( entries ) {
    entries.forEach( entry => {
      let href = `#${ entry.target.getAttribute('id') }`;
      let link = links.find( l => l.getAttribute('href') === href );

      if ( entry.isIntersecting && entry.intersectionRatio === 1 ) {
        link.classList.add('visible');
        prevSection = entry.target.getAttribute('id');
      } else {
        link.classList.remove('visible');
      }

      highlightActive();

    });
  }

  function init() {
    findLinksAndHeadings();

    headings.forEach( heading => {
      observer.observe( heading );
    });
  }

  init();

});

export default undefined;
